import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Moon, Menu, X } from "lucide-react";
import { CTAButton } from "@/components/landing/CTAButton";

const NAV = [
  ["Что разбираем", "#services"],
  ["Как это работает", "#how"],
  ["Цены", "#pricing"],
  ["Отзывы", "#reviews"],
  ["Вопросы", "#faq"],
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50"
      data-testid="site-header"
    >
      {/* Disclaimer strip */}
      <div
        className="w-full bg-[#0B0B1F]/90 backdrop-blur-md border-b border-[#D4AF6E]/10 px-4 py-1.5 text-center"
        data-testid="disclaimer-strip"
      >
        <p className="text-[10px] sm:text-xs tracking-wide text-[#EDE6D3]/50">
          Развлекательный формат. Не является медицинской, юридической, финансовой или психологической консультацией.
        </p>
      </div>

      {/* Nav bar */}
      <div className="glass border-b border-[#D4AF6E]/15">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-8">
          <a href="#hero" className="flex items-center gap-2.5" data-testid="logo-link">
            <span className="flex h-9 w-9 items-center justify-center rounded-full border border-[#D4AF6E]/40 bg-[#111133]">
              <Moon className="h-4 w-4 text-[#F0C674]" />
            </span>
            <span className="font-serif text-lg font-semibold text-[#EDE6D3] sm:text-xl">
              Бабушка Варвара
            </span>
          </a>

          <nav className="hidden items-center gap-8 lg:flex">
            {NAV.map(([label, href]) => (
              <a
                key={href}
                href={href}
                className="text-sm text-[#EDE6D3]/70 transition-colors hover:text-[#F0C674]"
              >
                {label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <CTAButton
              goal="cta_max_bot"
              size="sm"
              showArrow={false}
              testId="header-cta-bot"
              className="hidden sm:inline-flex"
            >
              Разбор в MAX
            </CTAButton>

            {/* Burger (mobile/tablet) */}
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              aria-label={open ? "Закрыть меню" : "Открыть меню"}
              aria-expanded={open}
              data-testid="burger-toggle"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-[#D4AF6E]/30 text-[#F0C674] transition-colors hover:bg-[#D4AF6E]/10 lg:hidden"
            >
              {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu panel */}
      <AnimatePresence>
        {open && (
          <motion.div
            key="mobile-menu"
            initial={{ opacity: 0, y: -12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -12 }}
            transition={{ duration: 0.28, ease: [0.16, 1, 0.3, 1] }}
            className="glass border-b border-[#D4AF6E]/15 lg:hidden"
            data-testid="mobile-menu"
          >
            <nav className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-4 sm:px-8">
              {NAV.map(([label, href], i) => (
                <a
                  key={href}
                  href={href}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-${i}`}
                  className="rounded-xl px-4 py-3 text-base text-[#EDE6D3]/80 transition-colors hover:bg-[#D4AF6E]/10 hover:text-[#F0C674]"
                >
                  {label}
                </a>
              ))}
              <div className="mt-3" onClick={() => setOpen(false)}>
                <CTAButton
                  goal="cta_max_bot"
                  testId="mobile-cta-bot"
                  className="w-full"
                >
                  Получить разбор
                </CTAButton>
              </div>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
